import { render } from "./create-supplier.vue?vue&type=template&id=2e6548a8"
import script from "./create-supplier.vue?vue&type=script&lang=js"
export * from "./create-supplier.vue?vue&type=script&lang=js"

import "./create-supplier.vue?vue&type=style&index=0&id=2e6548a8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__